import { List, Record } from 'immutable'

export interface ITodo {
  readonly mentions: List<string>
  readonly tags: List<string>
  readonly title: string
  readonly markup: string
  readonly isComplete: boolean
}

const TodoRecord = Record({
  isComplete: false,
  markup: '',
  mentions: List<string>(),
  tags: List<string>(),
  title: '',
})

export class Todo extends TodoRecord implements ITodo {
  public static fromJS(initialState?: any) {
    if (!initialState) {
      return new Todo()
    }

    const { mentions, tags, ...rest } = initialState

    return new Todo({
      mentions: List(mentions || []),
      tags: List(tags || []),
      ...rest,
    })
  }

  public readonly mentions: List<string>
  public readonly tags: List<string>
  public readonly title: string
  public readonly markup: string
  public readonly isComplete: boolean

  constructor(props?: Partial<Todo>) {
    props ? super(props) : super()
  }
}
